import { render } from "./InscriptionTbody.vue?vue&type=template&id=1b0e73c0&scoped=true"
import script from "./InscriptionTbody.vue?vue&type=script&lang=js"
export * from "./InscriptionTbody.vue?vue&type=script&lang=js"

import "./InscriptionTbody.vue?vue&type=style&index=0&id=1b0e73c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0e73c0"]])

export default __exports__